import React, { useState, useEffect } from "react";
import { useLaravelReactI18n } from "laravel-react-i18n";
import { Link } from "@inertiajs/react";

export default function CaseBlock({ data, locale }) {
    const { t } = useLaravelReactI18n();

    const [hasBlockClass, setHasBlockClass] = useState(false);

    useEffect(() => {
        const caseElement = document.querySelector('.news');
        setHasBlockClass(!!caseElement);
    }, []);

    return (
        hasBlockClass ? (
            <div className={"case-card"}>
                {
                    data.slug &&
                    <Link href={`/${locale}/cases/${data.slug}`} className="case-card__link">&nbsp;</Link>
                }
                <div className={"case-card__preview"}>
                    <img
                        src={`/storage/${data.image}`}
                        alt="card-preview"
                    />
                </div>
                <div className={"case-card__content"}>
                    <div className={"case-card__top"}>
                        <div className={"case-card__tag"}>{data.category}</div>
                        <div className={"case-card__link-icon"}>
                            <img src={require('@images/pages/cases/icon-arrow-diagonal.svg').default} alt="go to case page" />
                        </div>
                    </div>
                    <div className={"case-card__title"}>{data.name}</div>
                    <div className={"case-card__group"}>
                        <p className={"case-card__group-title"}>
                            {t("site.casesBlock.groupMainChallenge")}
                        </p>
                        <p
                            className={
                                "case-card__group-desc case-card__group-desc--purple"
                            }
                            dangerouslySetInnerHTML={{
                                __html: data.objective,
                            }}
                        ></p>
                    </div>
                    <Link href={`/${locale}/cases/${data.slug}`} className="case-card__btn mt-[25px]">{t("site.infoNewsCase.readMore")}</Link>
                </div>
            </div>) :
            <div className={"case-card"}>
                {
                    data.slug &&
                    <Link href={`/${locale}/cases/${data.slug}`} className="case-card__link">&nbsp;</Link>
                }
                <div className={"case-card__preview"}>
                    <img
                        src={`/storage/${data.image}`}
                        alt="card-preview"
                    />
                </div>
                <div className={"case-card__content"}>
                    {
                        data.slug ?
                            <div className={"case-card__top"}>
                                <div className={"case-card__tag"}>{data.category}</div>
                                <div className={"case-card__link-icon"}>
                                    <img src={require('@images/pages/cases/icon-arrow-diagonal.svg').default} alt="go to case page" />
                                </div>
                            </div> :
                            <div className={"case-card__tag"}>{data.category}</div>
                    }

                    <div className={"case-card__title"}>{data.name}</div>

                    {
                        data.client && (
                            <div className={"case-card__row"}>
                                <div className={"case-card__group"}>
                                    <p className={"case-card__group-title"}>
                                        {t("site.casesBlock.groupClient")}
                                    </p>
                                    <p
                                        className={
                                            "case-card__group-desc"
                                        }
                                        dangerouslySetInnerHTML={{
                                            __html: data.client,
                                        }}
                                    ></p>
                                </div>
                                <div className={"case-card__group"}>
                                    <p className={"case-card__group-title"}>
                                        {t("site.casesBlock.groupDuration")}
                                    </p>
                                    <p
                                        className={
                                            "case-card__group-desc"
                                        }
                                        dangerouslySetInnerHTML={{
                                            __html: data.project_duration,
                                        }}
                                    ></p>
                                </div>
                            </div>
                        )
                    }

                    {
                        data.objective && (
                            <div className={"case-card__group"}>
                                <p className={"case-card__group-title"}>
                                    {t("site.casesBlock.groupMainChallenge")}
                                </p>
                                <p
                                    className={
                                        "case-card__group-desc case-card__group-desc--purple"
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: data.objective,
                                    }}
                                ></p>
                            </div>
                        )
                    }
                    {
                        !data.takeaways && data.solution && !data.additional_title_content_1 && (
                            <div className={"case-card__row"}>
                                <div className={"case-card__group"}>
                                    <p className={"case-card__group-title"}>
                                        {t("site.casesBlock.groupWinningFormula")}
                                    </p>
                                    <p
                                        className={"case-card__group-desc"}
                                        dangerouslySetInnerHTML={{
                                            __html: data.solution,
                                        }}
                                    ></p>
                                </div>

                                <div className={"case-card__group"}>
                                    <p className={"case-card__group-title"}>
                                        {t("site.casesBlock.groupAchievements")}
                                    </p>
                                    <p
                                        className={"case-card__group-desc"}
                                        dangerouslySetInnerHTML={{
                                            __html: data.result,
                                        }}
                                    ></p>
                                </div>
                            </div>
                        )
                    }
                    {
                        data.takeaways && (
                            <>
                                <div className={"case-card__group"}>
                                    <p className={"case-card__group-title"}>
                                        {t("site.casesBlock.groupWinningFormula")}
                                    </p>
                                    <p
                                        className={
                                            "case-card__group-desc"
                                        }
                                        dangerouslySetInnerHTML={{
                                            __html: data.solution,
                                        }}
                                    ></p>
                                </div>
                                <div className={"case-card__row"}>
                                    <div className={"case-card__group"}>
                                        <p className={"case-card__group-title"}>
                                            {t("site.casesBlock.groupAchievements")}
                                        </p>
                                        <p
                                            className={"case-card__group-desc"}
                                            dangerouslySetInnerHTML={{
                                                __html: data.result,
                                            }}
                                        ></p>
                                    </div>

                                    <div className={"case-card__group"}>
                                        <p className={"case-card__group-title"}>
                                            {t("site.casesBlock.groupTakeaways")}
                                        </p>
                                        <p
                                            className={"case-card__group-desc"}
                                            dangerouslySetInnerHTML={{
                                                __html: data.takeaways,
                                            }}
                                        ></p>
                                    </div>
                                </div>
                            </>
                        )
                    }
                    {
                        data.additional_title_content_1 && data.additional_title_content_2 && (
                            <>
                                <div className={"case-card__group"}>
                                    <p className={"case-card__group-title"}>
                                        {t("site.casesBlock.groupWinningFormula")}
                                    </p>
                                    <p
                                        className={
                                            "case-card__group-desc"
                                        }
                                        dangerouslySetInnerHTML={{
                                            __html: data.solution,
                                        }}
                                    ></p>
                                </div>
                                <div className={"case-card__row"}>
                                    <div className={"case-card__group"}>
                                        <p className={"case-card__group-title"}
                                            dangerouslySetInnerHTML={{
                                                __html: data.additional_title_1,
                                            }}
                                        ></p>
                                        <p
                                            className={"case-card__group-desc"}
                                            dangerouslySetInnerHTML={{
                                                __html: data.additional_title_content_1,
                                            }}
                                        ></p>
                                    </div>

                                    <div className={"case-card__group"}>
                                        <p className={"case-card__group-title"}
                                            dangerouslySetInnerHTML={{
                                                __html: data.additional_title_2,
                                            }}
                                        ></p>
                                        <p
                                            className={"case-card__group-desc"}
                                            dangerouslySetInnerHTML={{
                                                __html: data.additional_title_content_2,
                                            }}
                                        ></p>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
            </div>
    );
}
